import classNames from 'classnames'
import { Icon, IconProps } from '@alto-avios/alto-ui'
import { useAlertContext } from './AlertProvider'
import styles from './AlertIcon.module.scss'

export const AlertIcon = (props: IconProps) => {
  const { iconName, iconSize, ...other } = props
  const { status, variant } = useAlertContext()

  return (
    <Icon
      {...other}
      data-status={status}
      iconName={iconName}
      iconSize={iconSize}
      className={classNames(styles.icon, styles[variant])}
    />
  )
}
